import ChannelsAppsSidebarList from "@/chat/sidebar/channels/ChannelsAppsSidebarList"
import ChannelsProductsSidebarList from "@/chat/sidebar/channels/ChannelsProductsSidebarList"
import { ChannelsNavSectionFragment$key } from "@/chat/sidebar/channels/__generated__/ChannelsNavSectionFragment.graphql"
import CommunitySidebarItem from "@/organization/common/sidebar/CommunitySidebarItem"
import { DiscoText } from "@disco-ui"
import { useTheme } from "@material-ui/core"
import { TestIDProps } from "@utils/typeUtils"
import { graphql, useFragment } from "react-relay"
import classes from "./ChannelsNavSection.module.css"

type Props = TestIDProps & {
  navSectionKey: ChannelsNavSectionFragment$key
}

export default function ChannelsNavSection(props: Props) {
  const { navSectionKey, testid = "ChannelsNavSection" } = props
  const theme = useTheme()

  const navSection = useFragment<ChannelsNavSectionFragment$key>(
    graphql`
      fragment ChannelsNavSectionFragment on NavSection {
        id
        kind
        title
        viewerExternalChannelIds
        ...ChannelsAppsSidebarList_NavSectionPaginationFragment
        ...ChannelsProductsSidebarList_NavSectionPaginationFragment
      }
    `,
    navSectionKey
  )
  const isProducts = navSection.kind === "products"

  return (
    <CommunitySidebarItem
      testid={testid}
      menuItemClasses={{ root: classes.menuItem }}
      name={navSection.title}
      collapsible
      ignoreLocalStorage
      nameNode={
        <DiscoText
          variant={"body-sm-500-uppercase"}
          truncateText={1}
          color={
            theme.palette.type === "dark" ? "groovy.onDark.300" : "groovy.neutral.400"
          }
        >
          {navSection.title}
        </DiscoText>
      }
      notificationConfig={{
        streamChannelIds: navSection.viewerExternalChannelIds as string[],
      }}
    >
      <div data-testid={`${testid}.children`}>
        {isProducts ? (
          <ChannelsProductsSidebarList
            testid={`${testid}.products`}
            navSectionKey={navSection}
          />
        ) : (
          <ChannelsAppsSidebarList navSectionKey={navSection} testid={testid} />
        )}
      </div>
    </CommunitySidebarItem>
  )
}
